import React from "react";
import { Helmet } from "react-helmet";
import { Title } from "../components/common/Title/Title";

const News = () => {
  const news = [
    {
      title: "L'Observateur du Maroc et d'Afrique",
      url: "https://lobservateur.info/ampArticle/20998",
    },
    {
      title: "Ma3azef | معازف",
      url: "https://ma3azef.com/%D9%84%D9%85%D8%A8%D9%88%D9%82-%D8%A7%D9%84%D8%AC%D8%B1%D8%A7%D9%86%D8%AF%D9%8A-%D8%B7%D9%88%D8%B7%D9%88/",
    },
    {
      title: "Welovebuzz | WLB",
      url: "https://www.welovebuzz.com/qui-est-lembawe9-ce-youtubeur-marocain-qui-detecte-les-graines-de-star-marocaines/",
    },
    {
      title: "Billboard Arabia | بيلبورد عربية",
      url: "https://www.billboardarabia.com/%D9%85%D9%88%D8%B3%D9%8A%D9%82%D9%89/%D9%87%D9%8A%D8%A8-%D9%87%D9%88%D8%A8-%D8%B9%D8%B1%D8%A8%D9%8A/11-%D8%B3%D8%A7%D9%8A%D9%81%D8%B1-%D9%87%D9%8A%D8%A8-%D9%87%D9%88%D8%A8-%D8%B9%D8%B1%D8%A8%D9%8A-%D9%84%D9%82%D8%A7%D8%A1%D8%A7%D8%AA-%D8%B5%D9%86%D8%B9%D8%AA-%D8%B0%D8%A7%D9%83%D8%B1%D8%A9-%D8%A7%D9%84%D8%AC%D9%86%D8%B1%D8%A7-5434?fbclid=PAVERFWANbPedleHRuA2FlbQIxMQABp_MMPoLSpM5OQP-tT8KrJomA1g-KemSHOFOyKIOQiCq5ozUyPVTHY6I6H0G2_aem_1gUI5zTl-ZmPuJYG29nZaA",
    },

  ]
  return (
    <>
      <Helmet>
          <title>Lembawe9 - News</title>
          <meta 
              name="description" 
              content="Official website of Lembawe9, the influential Moroccan street rap artist. Listen, shop, and connect." 
          />
      </Helmet>
      <main className="news">
        <Title 
            Title='' 
            SpanTitle='News' 
            Description=''
        />
        <div className="bg-light">
          {news.map((item, index) => (
            <div key={index}>
                  <Title 
                  Title='' 
                  SpanTitle={item.title} 
                  Description=''
              />
              <iframe
                src={item.url}
                title="description"
                width="100%" 
                style={{
                  backgroundColor: 'white !important',
                }}
              />
            </div>
          ))}
        </div>
      </main>
    </>
  );
};

export default News;
